export const brandPage = 'brand page';
export const landingPage = 'landing page';
export const shopPage = 'shop page';
export const shopFullMenu = 'shop full menu';
export const scheduleShopFullMenu = 'schedule shop full menu';
export const scheduleShopPage = 'schedule shop page';
export const dealsPopup = 'deals popup';
